/**
 * Fixes known misspellings in device model names returned by the backend.
 * Currently handles: "Biotech" → "BioTek"
 */
export const fixDeviceModel = (model: string): string =>
  model.replaceAll(/biotech/gi, 'Biotek')
